export { AnyGameLoader as default } from "../componentsF/AnyGameLoaderPageF.jsx"